import fetch from '@/utils/fetch';

export default {
  // 上传裁剪图片
  uploadAvatar: data => {
    return fetch({
      url: 'avatar/upload',
      method: 'post',
      data
    });
  },
  // 更新用户头像
  changeAvatar: data => {
    return fetch({
      url: 'users/change-avatar',
      method: 'put',
      data
    });
  },
  // 获取职业类型/机构类型
  getProfessionTypes: params => {
    return fetch({
      url: 'inquiry/professiontypes',
      method: 'get',
      params
    })
  },
  // 获取相关专业
  getDesignTypes: params => {
    return fetch({
      url: 'inquiry/designtypes',
      method: 'get',
      params
    })
  },
  // 获取国家、省份、城市信息 参数parentid.eq
  getLocations: params => {
    if (params) {
      params.size = 239
    } else {
      params = {
        size: 239
      }
    }
    return fetch({
      url: 'inquiry/locations',
      method: 'get',
      params
    })
  },
  // 获取所有国家
  getAllCountry: () => {
    return fetch({
      url: 'inquiry/locations/country',
      method: 'get'
    })
  },
  // 获取手机验证码
  sendCaptcha: data => {
    return fetch({
      url: 'send-captcha',
      method: 'post',
      data
    })
  },
  // 注册第一步
  register: data => {
    return fetch({
      url: 'register',
      method: 'post',
      data
    })
  },
  // 注册第二步
  registerComplete: data => {
    return fetch({
      url: 'register-complete',
      method: 'put',
      data
    })
  },
  // 登录
  login: data => {
    return fetch({
      url: 'login',
      method: 'post',
      data
    })
  },
  // 修改密码
  changePwd: data => {
    return fetch({
      url: 'users/change-password',
      method: 'put',
      data
    })
  },
  // 找回密码
  resetPwd: data => {
    return fetch({
      url: 'users/reset-password-new',
      method: 'put',
      data
    })
  }
}